import type { IPlayer } from "@ihs-widget/components/StatsConsole/Widgets/LineupWidget/parts/Players";


export const positionOrder: Record<string, number> = {
    'striker': 1,
    'left_winger': 2,
    'right_winger': 3,
    'central_midfielder': 4,
    'left_back': 5,
    'right_back': 6,
    'central_defender': 7,
    'goalkeeper': 8
  } as const;

  const sortByInjuriesAndCards = (players: IPlayer[]) => {
    // Filter players who are not on the field AND have either a red card or an injury
    // const playersOutOnField = players.filter(p => !p.isCurrentlyOnField && (p.redCard || p.injury));
    const playersOutOnField = players.filter(p => (p.redCard || p.injury));
    
    // Create a new sorted array from the filtered players
    return [...playersOutOnField].sort((a: IPlayer, b: IPlayer) => {
      // Define a helper function to determine sorting priority based on player status
      const getPriority = (player: IPlayer): number => {
        // Players with red cards get highest priority (lowest number = 1)
        if (player.redCard) return 1;
        // Players with injuries get second priority (2)
        if (player.injury) return 2;
        // All other players get lowest priority (3)
        return 3;
      };

      // Calculate priority values for both players being compared
      const priorityA = getPriority(a);
      const priorityB = getPriority(b);

      // First compare players by their priority (red card, injury, other)
      if (priorityA !== priorityB) {
        // Lower number means higher priority in the sorted list
        return priorityA - priorityB;
      }

      // If players have the same priority (both red carded or both injured),
      // then sort them by their field position according to predefined position order
      return (positionOrder[a.position] || 0) - (positionOrder[b.position] || 0);
    });
  };

export const sortBySubstitutions = (players: IPlayer[]) => {
    const benchPlayers = players?.filter(p => !p.isCurrentlyOnField) || []; // TODO: after API will be adjusted with isPlayerInPlay? 
    return [...benchPlayers]?.sort((a: IPlayer, b: IPlayer) => {
      // First substitutions
      if (a.substitutionTime !== b.substitutionTime) {
        return a.substitutionTime ? -1 : 1;
      }
      // Then by position
      return (positionOrder[a.position] || 0) - (positionOrder[b.position] || 0);
    });
  };

  export   const sortPlayers = (players: IPlayer[], isInjuries: boolean) => {
    return isInjuries ? sortByInjuriesAndCards(players) : sortBySubstitutions(players);
  };